// This function is used for formating date based on windows language.
const DateFormat = (cdate: any) => {
  return DateFormatter(new Date(cdate));
};

const DateFormatter = (value: Date) =>
  new Date(value).toLocaleString(window.navigator.language, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

const DateFormatGraph = (cdate: any) => {
  return DateFormatterGraph(new Date(cdate));
};

const DateFormatterGraph = (value: Date) =>
  new Date(value).toLocaleString(window.navigator.language, {
    hour: '2-digit',
  });

export { DateFormat, DateFormatter, DateFormatGraph, DateFormatterGraph };
